import { create } from 'zustand';
import { api } from '../lib/api/client';

interface AuthState {
  token: string | null;
  user: any | null;
  isLoggedIn: boolean;
  isAdmin: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, name?: string) => Promise<void>;
  logout: () => void;
  fetchMe: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('token'),
  user: null,
  isLoggedIn: !!localStorage.getItem('token'),
  isAdmin: false,
  login: async (email, password) => {
    const res = await api.auth.login({ email, password });
    localStorage.setItem('token', res.token);
    set({ token: res.token, user: res.user, isLoggedIn: true, isAdmin: res.user.role === 'admin' });
  },
  register: async (email, password, name) => {
    const res = await api.auth.register({ email, password, name });
    localStorage.setItem('token', res.token);
    set({ token: res.token, user: res.user, isLoggedIn: true, isAdmin: false });
  },
  logout: () => {
    localStorage.removeItem('token');
    set({ token: null, user: null, isLoggedIn: false, isAdmin: false });
  },
  fetchMe: async () => {
    try {
      const user = await api.auth.me();
      set({ user, isLoggedIn: true, isAdmin: user.role === 'admin' });
    } catch {
      localStorage.removeItem('token');
      set({ token: null, user: null, isLoggedIn: false, isAdmin: false });
    }
  },
}));
